import styles from "../../styles/addInvoice.module.css";

export default function InvoiceDetailsHeader() {
  return (
    <div className={styles["invoice-details-header"]}>
      <h1>
        <i className={`fa-solid fa-file ${styles["icon-invoice-details"]}`}></i>
        Detalles de la Factura
      </h1>
    </div>
  );
}
